import { createGlobalStyle } from "styled-components"

// ============================================================================
// GLOBAL STYLES
// ============================================================================

export const CustomVideoExtensionStyles = createGlobalStyle`
  /* ============================================================================
     VIDEO WRAPPER BASE STYLES
     ============================================================================ */
  
  .remirror-video-wrapper {
    position: relative;
    overflow: visible;
    margin: 0.5rem 0px;
    border-radius: 8px;
    max-width: 100%;
    border: 1px solid white;
    transition: border-color 0.2s ease;
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    .remirror-video-wrapper {
      height: auto!important;
    }
  }

  .remirror-video-wrapper video {
    display: block;
    width: 100%;
    height: 100%; 
    min-width: 0;
    min-height: 0;
  }

  .remirror-video-wrapper iframe {
    width: 100% !important;
    height: 100% !important;
    border: none;
    border-radius: 8px;
  }

  /* ============================================================================
     SELECTION AND HOVER STATES
     ============================================================================ */

  .remirror-video-wrapper:hover {
    outline: 2px solid #f0f0f0!important;
  }

  .remirror-video-wrapper[data-selected="true"] {
    outline: 2px solid #6567eb!important;
  }

  /* ============================================================================
     ASPECT RATIO AND RESPONSIVE BEHAVIOR
     ============================================================================ */

  .remirror-video-wrapper.responsive-video {
    aspect-ratio: 16 / 9;
  }

  .remirror-video-wrapper[style*="aspect-ratio"] {
    height: auto !important;
    overflow: visible !important;
  }

  /* ============================================================================
     SIZE VARIANTS
     ============================================================================ */

  /* Size variants removed - videos now use free resizing */


  /* ============================================================================
     RESIZE HANDLE
     ============================================================================ */

  .remirror-video-wrapper .resize-handle-single {
    width: 32px;
    height: 32px;
    position: absolute;
    bottom: 6px;
    right: 6px;
    background: white;
    border: 1px solid white;
    cursor: nwse-resize;
    border-radius: 50%;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    opacity: 0;
    transform: scale(0.8);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 767px) {
    .remirror-video-wrapper .resize-handle-single {
      width: 20px;
      height: 20px;
      bottom: 2px;
      right: 2px;
    }
  }

  .resize-handle-single::after {
    content: "⤡";
    font-size: 24px;
  }

  @media (max-width: 767px) {
    .remirror-video-wrapper .resize-handle-single::after {
      font-size: 14px;
    }
  }

  .remirror-video-wrapper:hover .resize-handle-single,
  .remirror-video-wrapper.ProseMirror-selectednode .resize-handle-single {
    background: white!important;
    opacity: 1!important;
  }

  .remirror-video-wrapper:hover .resize-handle-single:hover {
    transform: scale(1)!important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15)!important;
  }

  /* ============================================================================
     DRAG HANDLER
     ============================================================================ */

  .remirror-drag-handler {
    position: absolute;
    left: -24px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;
    cursor: grab;
    z-index: 20;
  }

  .remirror-drag-handler:active {
    cursor: grabbing;
  }

  .remirror-video-wrapper:hover .remirror-drag-handler,
  .remirror-video-wrapper[data-selected="true"] .remirror-drag-handler {
    opacity: 0.7;
  }

  .remirror-drag-handler:hover {
    opacity: 1 !important;
  }

  .remirror-drag-handler svg {
    width: 16px;
    height: 16px;
    color: #7c3aed;
  }

  /* ============================================================================
     CONTEXT MENU
     ============================================================================ */

  .remirror-context-menu {
    position: absolute;
    top: -40px;
    right: 0;
    background: white;
    border-radius: 6px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    display: flex;
    padding: 4px;
    z-index: 30;
    opacity: 0;
    transform: translateY(10px);
    pointer-events: none;
    transition: opacity 0.2s ease, transform 0.2s ease;
  }

  .remirror-context-menu.visible {
    opacity: 1;
    transform: translateY(0);
    pointer-events: all;
  }

  .remirror-context-menu-button {
    background: transparent;
    border: none;
    border-radius: 4px;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #555;
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  .remirror-context-menu-button:hover {
    background-color: #f0f0f0;
    color: #7c3aed;
  }

  .remirror-context-menu-button.delete:hover {
    background-color: #fee2e2;
    color: #ef4444;
  }

  .remirror-context-menu-button svg {
    width: 16px;
    height: 16px;
  }

  /* ============================================================================
     PROGRESS BADGE
     ============================================================================ */

  .remirror-video-wrapper .progress-badge {
    position: absolute;
    bottom: 8px;
    right: 8px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 12px;
    pointer-events: none;
    opacity: 1;
    transition: opacity 0.3s ease, transform 0.3s ease;
    z-index: 20;
  }

  .remirror-video-wrapper[data-uploading="false"] .progress-badge {
    opacity: 0;
    transform: translateY(10px);
    pointer-events: none;
    visibility: hidden;
  }

  /* ============================================================================
     RESIZE STATE
     ============================================================================ */

  .remirror-video-wrapper.resizing {
    user-select: none;
  }

  .remirror-video-wrapper.resizing iframe,
  .remirror-video-wrapper.resizing video {
    pointer-events: none;
  }

  /* ============================================================================
     VIDEO TRANSITION WRAPPER
     ============================================================================ */

  .video-transition-wrapper {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  .video-transition-wrapper.video-loaded {
    opacity: 1;
  }
`
